import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { CheckboxField } from "@aws-amplify/ui-react";
import {
  LATEST_TERMS_UPDATE,
  TERMS_OF_USE_PATH,
  TERMS_OF_VIEWER
} from "../../constants/Constant";
import { useAuthStatus } from "../../context/AuthContext";
import { getServerTime } from "../../utils/Util";
import { Auth } from "aws-amplify";

const TermsOfUseUpdateModal = ({ show, handleClose }) => {
  const [touched, setTouched] = useState(false);
  const [isConsentCheck, setIsConsentCheck] = useState(false);
  const [isReceiveEmail, setIsReceiveEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userInfo } = useAuthStatus();

  useEffect(() => {
    if (userInfo) {
      setIsReceiveEmail(
        userInfo?.attributes["custom:marketingmailreceive"] === "true"
      );
    }
  }, [userInfo]);

  const handleUseNoLogin = async () => {
    try {
      await Auth.signOut();
    } catch (error) {
      console.error(error);
    } finally {
      handleClose();
    }
  };

  const updateTermsConsentDate = async () => {
    // スピナー表示
    setLoading(true);
    try {
      const serverTime = await getServerTime();
      // チェックの変更があったか比較し、変更があった場合のみ同意日時を登録する
      const isChangeReceiveEmail =
        userInfo?.attributes["custom:marketingmailreceive"] !==
        isReceiveEmail.toString();
      const result = await Auth.updateUserAttributes(userInfo, {
        "custom:lastconsentdatetime": serverTime.toISOString(),
        "custom:marketingmailreceive": isReceiveEmail.toString(),
        ...(isChangeReceiveEmail
          ? { "custom:marketmaildatetime": serverTime.toISOString() }
          : {}),
      });
      console.log(result);
    } catch (error) {
      console.error(error);
      alert("アカウントの更新に失敗しました");
    } finally {
      // スピナー非表示
      setLoading(false);
      handleClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      centered
    >
      <Modal.Header>
        <Modal.Title className="w-100 text-center">
          MAPPLE法務局地図ビューア
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-5">
        <h3 className="mb-3 text-center">
          利用規約改定のお知らせと再同意のお願い
        </h3>
        <p className="mb-3" style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>
          平素より「MAPPLE法務局地図ビューア」をご利用いただき、誠にありがとうございます。
        </p>
        <p className="mb-3" style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>
          この度、{getTermsUpdateDate()}付で利用規約およびアカウント利用規約を改定いたしました。サービスを継続してご利用いただくためには、内容をご確認いただき、ご同意いただく必要がございます。
        </p>

        {/* 同意チェックボックス（規約エリアの上に配置） */}
        <div className="mb-3 p-2" style={{ backgroundColor: "#fffbe6", border: "1px solid #ffe58f", borderRadius: "4px" }}>
          <CheckboxField
            errorMessage="利用規約およびアカウント利用規約に同意し、チェックを入れてください"
            hasError={touched && !isConsentCheck}
            checked={isConsentCheck}
            name="acknowledgement"
            value="yes"
            className="bs-color-checkbox"
            onChange={(e) => {
              setTouched(true);
              setIsConsentCheck(e.target.checked);
            }}
            label={
              <div style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                <a href={TERMS_OF_VIEWER} target="_blank" rel="noopener noreferrer">利用規約</a>
                {" および "}
                <a href={TERMS_OF_USE_PATH} target="_blank" rel="noopener noreferrer">アカウント利用規約</a>
                {" に同意する"}
              </div>
            }
          />
        </div>

        {/* 規約表示エリア（グレーの背景でブロック化） */}
        <div className="p-3 mb-4" style={{ backgroundColor: "#f9f9f9", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div className="mb-3">
            <div className="fw-bold mb-1" style={{ fontSize: "0.85rem", color: "#666" }}>【利用規約】</div>
            <iframe
              src={TERMS_OF_VIEWER}
              className="w-100 border border-1 bg-white"
              height="180"
              title="ViewerTerms"
            ></iframe>
          </div>

          <div>
            <div className="fw-bold mb-1" style={{ fontSize: "0.85rem", color: "#666" }}>【アカウント利用規約】</div>
            <iframe
              src={TERMS_OF_USE_PATH}
              className="w-100 border border-1 bg-white"
              height="180"
              title="AccountTerms"
            ></iframe>
          </div>
        </div>

        <CheckboxField
          className="bs-color-checkbox pb-3"
          label="MAPPLE法務局地図ビューアからの各種案内のメールを受け取る"
          name="custom:marketingmailreceive"
          checked={isReceiveEmail}
          onChange={(e) => setIsReceiveEmail(e.target.checked)}
        />

        <Button
          variant="primary"
          className="w-100 py-2 fw-bold"
          disabled={!isConsentCheck || loading}
          onClick={updateTermsConsentDate}
        >
          {loading && (
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
          )}
          同意してログインする
        </Button>

        <div className="w-100 text-center mt-3">
          <Button variant="link" size="sm" onClick={handleUseNoLogin} className="text-decoration-none text-secondary">
            ログインしないで使う
          </Button>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="justify-content-center py-2 text-secondary" style={{ fontSize: "0.8rem" }}>
        &copy; MAPPLE,Inc.
      </Modal.Footer>
    </Modal>
  );
};

const getTermsUpdateDate = () => {
  return new Date(LATEST_TERMS_UPDATE).toLocaleDateString("ja-JP", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export default TermsOfUseUpdateModal;
